const API_URL =
  process.env.NODE_ENV === "production" &&
  process.env.REACT_APP_HOST_ENV === "production"
    ? "https://api.suarte.art"
    : "https://dev.suarte.art";

export default API_URL;
